const info = require("./lib/config/info");
const plugins = require("./lib/config/plugins");
const stripe = require("./lib/config/stripe");
const reviews = require("./lib/reviews");
const trips = require("./lib/trips");

module.exports = {
  siteMetadata: Object.assign(
    {
      stripe,
      reviews,
      trips,
      axiosHeaders: {
        accept: "application/json",
        "accept-language": "en_US",
        "content-type": "application/x-www-form-urlencoded",
      },
    },
    info
  ),
  plugins: plugins,
};



// WEBPACK FOOTER //
// ./gatsby-config.js